import React from "react";
import classnames from "classnames";

const TabItem = (props) => {
    return (
        <button
            className={classnames("button -text", { "-active": props.selected === props.id })}
            onClick={() => {
                props.onClick(props.id);
            }}
        >
            {props.label}
        </button>
    );
};

export default TabItem;
